import { Link } from "react-router-dom";
import { Button, Image } from "semantic-ui-react";
import useSite from "../../../../../../../permits/components/inspections/InspectionPanel/useSite";

interface INotifyNotificationsEmptyList {
  header: string;
  message: string;
  showCreateButton?: boolean;
}

export function NotifyNotificationsEmptyList({
  header,
  message,
  showCreateButton = true,
}: INotifyNotificationsEmptyList) {
  const site = useSite();
  return (
    <div className='tw-mx-10 tw-flex tw-flex-col tw-items-center tw-gap-3 tw-text-center'>
      <Image src='/assets/gogov-logo2.svg' className='tw-w-16' />
      <p className='tw-m-0 tw-text-2xl tw-font-bold'>{header}</p>
      <p>{message}</p>
      {showCreateButton && (
        <Button
          as={Link}
          color='blue'
          icon='plus'
          content='Create'
          to={`/${site}/notify/notifications/create/from-template`}
        />
      )}
    </div>
  );
}
